import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ScreenSizes } from '../../classes/screen-sizes.class';
import { CopyToClipboard } from '../../lib/copy-to-clipboard';

@Directive({
  selector: '[share]',
  standalone: true,
})
export class ShareDirective {
  @Input('share') public payload: string;
  @Input() shareTitle: string;
  @Input() shareText: string;
  @Output() onCopied = new EventEmitter();
  @Output() onShareClicked = new EventEmitter();
  @Output() onShared = new EventEmitter();

  @HostListener('click', ['$event'])
  public onClick(): void {
    if (navigator.share && ScreenSizes.screenSize() !== 'desktop') {
      this.onShareClicked.emit();
      navigator
        .share({
          url: this.payload,
          title: this.shareTitle,
          text: this.shareText,
        })
        .then(() => {
          this.onShared.emit();
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      CopyToClipboard(this.payload);
      this.onCopied.emit();
    }
  }
}
